export enum HeadingType{
    H1,
    H2,
    H3,
    H4,
    H5,
    H6
}